import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";

import CreateClient from "./CreateClient";
import AuditSheetUploader from "../Audit/AuditSheetUploader";
import ViewUploadedStatement from "../Audit/ViewUploadedStatement";
import SmeProfileIcon from "../../components/Icons/SmeProfileIcon";
import UploadStatementsIcon from "../../components/Icons/UploadStatementsIcon";
import ViewBalanceIcon from "../../components/Icons/ViewBalanceIcon";
import { CLIENT_BACKGROUND_TABS } from "../../constants/ui";
import SMEProfile from "./SMEProfile";
import SWOTView from "./SWOTView";
import EditIcon from "../../components/Icons/EditIcon";
import Loader from "../../components/Loader/Loader";
import ClientEditProfile from "./ClientEditProfile";
import Chatbot from "./Chatbot";
import { useParams } from 'react-router-dom';

const ClientBackgroundLinks = ({
  currentTab,
  changeTab,
  isAuthenticatedUser,
  currentClient,
  currentUserClients,
}) => {
  
  return (
    <Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === CLIENT_BACKGROUND_TABS.VIEW_PROFILE
              ? "SMEBackgroundSubTabs tab-selected"
              : "SMEBackgroundSubTabs"
          }
          style={{ display: "flex" }}
          _hover={{}}
          onClick={() => changeTab(CLIENT_BACKGROUND_TABS.VIEW_PROFILE)}
        >
          <Box mr={"5px"}>
            <SmeProfileIcon
              color={
                currentTab === CLIENT_BACKGROUND_TABS.VIEW_PROFILE
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>View Profile</Box>
        </Text>
      </Box>
      {isAuthenticatedUser &&
        currentClient &&
        currentClient._id.includes(currentUserClients) && (
          <Box m={"0px"} w={"100%"}>
            <Text
              className={
                currentTab === CLIENT_BACKGROUND_TABS.EDIT_PROFILE
                  ? "SMEBackgroundSubTabs tab-selected"
                  : "SMEBackgroundSubTabs"
              }
              style={{ display: "flex" }}
              _hover={{}}
              onClick={() => changeTab(CLIENT_BACKGROUND_TABS.EDIT_PROFILE)}
            >
              <Box mr={"5px"}>
                <EditIcon
                  color={
                    currentTab === CLIENT_BACKGROUND_TABS.EDIT_PROFILE
                      ? "#FFFFFF"
                      : "#5D5D5D"
                  }
                />
              </Box>
              <Box>Edit Profile</Box>
            </Text>
          </Box>
        )}
      {isAuthenticatedUser &&
        currentClient &&
        currentClient._id.includes(currentUserClients) && (
          <Box m={"0px"} w={"100%"}>
            <Text
              className={
                currentTab === CLIENT_BACKGROUND_TABS.UPLOAD_STATEMENT
                  ? "SMEBackgroundSubTabs tab-selected"
                  : "SMEBackgroundSubTabs"
              }
              style={{ display: "flex" }}
              _hover={{}}
              onClick={() => changeTab(CLIENT_BACKGROUND_TABS.UPLOAD_STATEMENT)}
            >
              <Box mr={"5px"}>
                <UploadStatementsIcon
                  color={
                    currentTab === CLIENT_BACKGROUND_TABS.UPLOAD_STATEMENT
                      ? "#FFFFFF"
                      : "#5D5D5D"
                  }
                />
              </Box>
              <Box>Upload Statement</Box>
            </Text>
          </Box>
        )}
      {isAuthenticatedUser &&
        currentClient &&
        currentClient._id.includes(currentUserClients) && (
          <Box m={"0px"} w={"100%"}>
            <Text
              className={
                currentTab === CLIENT_BACKGROUND_TABS.VIEW_PAST_PERFORMANCE
                  ? "SMEBackgroundSubTabs tab-selected"
                  : "SMEBackgroundSubTabs"
              }
              style={{ display: "flex" }}
              _hover={{}}
              onClick={() =>
                changeTab(CLIENT_BACKGROUND_TABS.VIEW_PAST_PERFORMANCE)
              }
            >
              <Box mr={"5px"}>
                <ViewBalanceIcon
                  color={
                    currentTab === CLIENT_BACKGROUND_TABS.VIEW_PAST_PERFORMANCE
                      ? "#FFFFFF"
                      : "#5D5D5D"
                  }
                />
              </Box>
              <Box>View Balance Sheet, Audit Data</Box>
            </Text>
          </Box>
        )}
     
        {/* {isAuthenticatedUser &&
        currentClient._id.includes(currentUserClients) && (
          <Box m={"0px"} w={"100%"}>
            <Text
              className={
                currentTab === CLIENT_BACKGROUND_TABS.CHATBOT
                  ? "SMEBackgroundSubTabs tab-selected"
                  : "SMEBackgroundSubTabs"
              }
              style={{ display: "flex" }}
              _hover={{}}
              onClick={() => changeTab(CLIENT_BACKGROUND_TABS.CHATBOT)}
            >
              <Box mr={"5px"}>
                <ViewBalanceIcon
                  color={
                    currentTab === CLIENT_BACKGROUND_TABS.CHATBOT
                      ? "#FFFFFF"
                      : "#5D5D5D"
                  }
                />
              </Box>
              <Box>Chatbot</Box>
            </Text>
          </Box>
        )} */}
    </Box>
  );
};

const TabContent = ({ tab, clientData }) => {
  
  switch (tab) {
    case CLIENT_BACKGROUND_TABS.VIEW_PROFILE:
      return <SMEProfile clientData={clientData} />;
    case CLIENT_BACKGROUND_TABS.EDIT_PROFILE:
      return <ClientEditProfile clientData={clientData} />;
    case CLIENT_BACKGROUND_TABS.UPLOAD_STATEMENT:
      return <AuditSheetUploader clientData={clientData} />;
    case CLIENT_BACKGROUND_TABS.VIEW_PAST_PERFORMANCE:
      return <ViewUploadedStatement clientData={clientData} />;
    case CLIENT_BACKGROUND_TABS.SWOT_VIEW:
      return <SWOTView clientId={clientData._id} />;
      // case CLIENT_BACKGROUND_TABS.CHATBOT:
      //   return <Chatbot  />;
  }
};

const SMEBackground = () => {
  const {
    loading: userLoading,
    isAuthenticatedUser,
    data: userData,
  } = useSelector((state) => state.userReducer);
  const { loading: clientLoading, data: clientData } = useSelector(
    (state) => state.clientReducer
  );
  const [currentTab, setCurrentTab] = useState(
    CLIENT_BACKGROUND_TABS.VIEW_PROFILE
  );
  const [currentUserClients, setCurrentUserClients] = useState([]);
  console.log("===userData", userData, currentUserClients);
  const changeTab = (newTab) => {
    setCurrentTab(newTab);
  };

  useEffect(() => {
    if (!userLoading && userData?.client) {
      setCurrentUserClients([userData?.client?._id]);
    }
  }, [userLoading]);
  return (
    <>
      <Box margin="0px" className="SMEBackgroundBoxShadow">
        <HStack
          w={"100%"}
          spacing={4}
          alignItems={"start"}
          className="shadowBox"
        >
          <Box w={"200px!important"} h="350px" overflowY={"auto"}>
            <VStack
              // w={'70%'}
              spacing={4}
              m={1}
              className="leftNavOptions"
              alignItems={"center"}
              p="10px 3px"
            >
              {clientLoading ? (
                <Loader />
              ) : (
                <ClientBackgroundLinks
                  currentTab={currentTab}
                  changeTab={changeTab}
                  isAuthenticatedUser={isAuthenticatedUser}
                  currentClient={clientData}
                  currentUserClients={currentUserClients}
                />
              )}
            </VStack>
          </Box>
          <Box mt={2} w={"80%"}>
            {clientLoading ? (
              <Loader />
            ) : (
              <TabContent tab={currentTab} clientData={clientData} />
            )}
          </Box>
        </HStack>
      </Box>
    </>
  );
};

export default SMEBackground;
